
import {PRIVACY_STATEMENTS} from './types';
import {salomapi3} from '../apis';

export const fetchPrivacy =  (region) => async dispatch => {
    const response = await salomapi3.get('/privacy?region='+region);
    dispatch({type:PRIVACY_STATEMENTS,payload:response.data})
}